import _extends from 'babel-runtime/helpers/extends';
var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "implement-way" }, [_c('config-card', { ref: "form", attrs: { "title": "创意实现方式", "form-config": _extends({}, _vm.formConfig, { labelWidth: '150px' }), "form-value": _vm.formValue, "form-item-list": _vm.formItemList } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };